import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const KedmaIcon = createSvgIcon(
  <>
    <path
      d="M2.76561 11.0625V4.60937C2.76561 4.12038 2.95986 3.65141 3.30563 3.30564C3.6514 2.95988 4.12036 2.76563 4.60935 2.76562H17.5156C18.0045 2.76563 18.4735 2.95988 18.8193 3.30564C19.165 3.65141 19.3593 4.12038 19.3593 4.60937V17.5156C19.3593 18.0046 19.165 18.4735 18.8193 18.8193C18.4735 19.1651 18.0045 19.3593 17.5156 19.3593H11.0625"
      {...strokeProps}
    />
    <path d="M2.76561 9.21875H19.3593" {...strokeProps} />
    <path d="M9.21872 2.76562V11.9843" {...strokeProps} />
    <path
      d="M1.84375 15.6719C1.84375 15.4274 1.94088 15.1929 2.11376 15.02C2.28664 14.8471 2.52113 14.75 2.76562 14.75H6.45311C6.6976 14.75 6.93209 14.8471 7.10497 15.02C7.27785 15.1929 7.37498 15.4274 7.37498 15.6719V19.3594C7.37498 19.6039 7.27785 19.8383 7.10497 20.0112C6.93209 20.1841 6.6976 20.2812 6.45311 20.2812H2.76562C2.52113 20.2812 2.28664 20.1841 2.11376 20.0112C1.94088 19.8383 1.84375 19.6039 1.84375 19.3594V15.6719Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'KedmaIcon', viewBox: '0 0 23 23' }
);
